import TomSelect from 'tom-select';

export function tomSelectInit() {

	const propertyLookup = document.querySelector('.property-lookup select');

	if (propertyLookup) {
		const config = {
			maxItems: 1,
			openOnFocus: false,
			shouldLoad:function(query){
				return ( query.length >= 3 )
			}
		};
		new TomSelect(propertyLookup, config);
	}	

	const universityLookup = document.querySelector('.university-lookup select');

	if (universityLookup) {
		const config = {
			plugins: {
				remove_button:{
					title:'Remove this item',
				}
			},
		};
		new TomSelect(universityLookup, config);
	}	

}
